export const ACCOUNT_LEVELS = [
  {
    id: 0,
    title: 'Nível 0',
    description:
      'Novo cadastro sem verificações concluídas. Permite acessar o painel, atualizar dados básicos, enviar, receber fundos em cripto e atualizar saldos.',
    requirements: ['Nenhuma verificação concluída'],
    limits: [
      'Depósitos e saques cripto',
      'Trade cripto',
      'Consultas de saldos e cadastro de dados pessoais',
    ],
  },
  {
    id: 1,
    title: 'Nível 1',
    description: 'Email verificado para liberar operações básicas em reais.',
    requirements: ['Email verificado'],
    limits: [
      'Benefícios Nível 0',
      'Depósitos Pix',
      'Saque em Reais',
    ],
  },
  {
    id: 2,
    title: 'Nível 2',
    description:
      'Complete seus dados pessoais obrigatórios para ampliar limites de conversão e saque.',
    requirements: ['Nome e sobrenome', 'CPF', 'Data de nascimento'],
    limits: [
      'Benefícios Nível 1',
      'Permite revisão cadastral completa',
      'Aumenta Limites diários de trade',      
    ],
  },
  // Níveis avançados serão reativados futuramente
  // {
  //   id: 3,
  //   title: 'Nível 3',
  //   description: 'Valide dados de contato e endereço para habilitar novos serviços.',
  //   requirements: ['Telefone / Celular', 'Endereço'],
  //   limits: [
  //     'Saques em reais com limites ampliados',
  //     'Depósitos em reais com limites maiores por operação',
  //     'Acesso a promoções e benefícios exclusivos',
  //   ],
  // },
  // {
  //   id: 4,
  //   title: 'Nível 4',
  //   description: 'Envie comprovantes oficiais para liberar limites elevados e operações avançadas.',
  //   requirements: ['Comprovante de identidade', 'Comprovante de endereço'],
  //   limits: [
  //     'Libera saques e depósitos em valores elevados',
  //     'Acesso a suporte dedicado de compliance',
  //     'Prioridade em análises manuais de limites',
  //   ],
  // },
  // {
  //   id: 5,
  //   title: 'Nível 5',
  //   description: 'Validação final com selfie para desbloquear todos os recursos Stackfy.',
  //   requirements: ['Foto (selfie)'],
  //   limits: [
  //     'Limites personalizados conforme análise',
  //     'Relacionamento direto com a mesa OTC Stackfy',
  //     'Suporte prioritário 24/7',
  //   ],
  // },
];

export const MAX_ACCOUNT_LEVEL = ACCOUNT_LEVELS[ACCOUNT_LEVELS.length - 1].id;

const clampLevel = (value) => {
  if (!Number.isFinite(value)) return 0;
  if (value < 0) return 0;
  if (value > MAX_ACCOUNT_LEVEL) return MAX_ACCOUNT_LEVEL;
  return Math.floor(value);
};

const castToNumber = (value) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : NaN;
};

export const isEmailVerified = (user) => Number(user?.validEmail) === 1;

export const getRegistrationStep = (user) => {
  if (!user) return 0;

  const candidates = [
    user?.userRegistrationStep,
    user?.registrationStep,
    user?.registration_step,
    user?.RegistrationStep,
    user?.registration_level,
  ];

  for (const candidate of candidates) {
    const parsed = castToNumber(candidate);
    if (Number.isFinite(parsed)) {
      return clampLevel(parsed);
    }
  }

  return 0;
};

// O nível é o `user_registration_step` que vem da API, e nada além dele: é esse o número que a
// esteira de limites usa para decidir se o depósito Pix passa. Ter e-mail verificado não promove
// para o nível 1 aqui — no backend as duas coisas são gravadas no mesmo UPDATE da validação de
// e-mail, então promover por conta própria só criaria a tela que anuncia um nível que o depósito
// depois recusa.
export const resolveUserLevel = (user) => {
  if (!user) return 0;

  if (!isEmailVerified(user)) {
    return 0;
  }

  return getRegistrationStep(user);
};

export const getNextPendingLevel = (user) => {
  if (!user) return 1;

  if (!isEmailVerified(user)) {
    return 1;
  }

  const step = getRegistrationStep(user);
  if (step >= MAX_ACCOUNT_LEVEL) {
    return null;
  }

  return clampLevel(step + 1);
};

export const getLevelById = (levelId) => ACCOUNT_LEVELS.find((level) => level.id === levelId);
